<template>
  <div>
    <v-btn
      small
      flat
      :class="{ 'btn-cancelar': true }"
      v-if="mostrarBtnCancelar"
      @click="cancelar"
    >{{ textoCancelar }}</v-btn>
    <v-btn
      small
      flat
      :class="{ 'btn-guardar': true }"
      :loading="guardando"
      :disabled="guardando"
      color="primary"
      v-if="mostrarBtnGuardar"
      @click="guardar"
    >
      {{ textoGuardar }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'BotonesCancelarGuardar',
  props: {
    guardando: {
      type: Boolean,
      defualt: false
    },
    textoCancelar: {
      type: String,
      default: 'Cancelar'
    },
    textoGuardar: {
      type: String,
      default: 'Guardar'
    },
    mostrarGuardar: {
      type: Boolean,
      default: true
    },
    mostrarCancelar: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      mostrarBtnGuardar: this.mostrarGuardar,
      mostrarBtnCancelar: this.mostrarCancelar
    }
  },
  methods: {
    guardar () {
      this.$emit('alGuardar')
    },
    cancelar () {
      this.$emit('alCancelar')
    }
  },
  watch: {
    mostrarGuardar (nuevo, viejo) {
      this.mostrarBtnGuardar = nuevo
    },
    mostrarCancelar (nuevo, viejo) {
      this.mostrarBtnCancelar = nuevo
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-guardar {
  background-color: #5e4295 !important;
  border-color: #604492 !important;
  border-radius: 15px;
  min-height: 30px;
  color: #ffffff !important;
  border: 2px solid;
}
.btn-cancelar {
  background-color: #fff !important;
  border-color: #604492 !important;
  border-radius: 15px;
  min-height: 30px;
  color: #604492 !important;
  border: 2px solid;
}
</style>
